var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=c5t5wnxp6mvabdrpn7wm4zt2zu/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spectator_login_for_image_button\">\n    <a class=\"login_button color_animated_button\" href=\"/login/\">\n        <i class='zulip-icon zulip-icon-log-in'></i>\n        <span class=\"color-animated-button-text\">"
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Log in to view image",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":4,"column":49},"end":{"line":4,"column":78}}}))
    + "</span>\n    </a>\n</div>\n";
},"useData":true});